import { Box } from '@mui/material';
import DapniLogo from 'assets/images/uniwooca.png';
import * as React from 'react';

const ProjectLogo: React.FC = () => {
    return (
        <Box display={'flex'} alignItems={'center'}>
            <img
                src={DapniLogo}
                alt={'Logo Image'}
                height={'20%'}
                width={'23%'}
                style={{ objectFit: 'cover', cursor: 'pointer' }}
            />
        </Box>
    );
};
export default ProjectLogo;
